import React, {
    useEffect,
    useState
} from 'react';
import renderHTML from 'react-render-html';
import FileViewerModel from 'components/fileViewer';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const NotificationBody = ({data, open=false, isAdmin, onClose=()=>{}}) => {
    const [viewDetail, setViewDetail] = useState(false);

    const message = data.body || "-";
    const messageString = message.replace(/<(.|\n)*?>/g, '');

    const subText = messageString.substring(0, 80);

    useEffect(() => {
        if(open && data) {
            setViewDetail(true);
        }
    }, [open]);

    const onCloseModel = () => {
        setViewDetail(false);
        onClose();
    }

    return (
        <>
            <div>{subText}{data.body && data.body.length > 80 ? <span onClick={() => setViewDetail(true)} className='text-info cursor-pointer'> ...Read More</span> : ""}</div>
            <Modal size="lg" isOpen={viewDetail} toggle={onCloseModel} centered>
                <ModalHeader toggle={onCloseModel}>{data.subject}</ModalHeader>
                <ModalBody>
                    {data.file_link ? <div className='d-flex justity-content-center mb-2'>
                        <FileViewerModel isAdmin={isAdmin} file_link={data.file_link} file_type={data.file_type} subject={data.subject} />
                    </div> : null}
                    {data.body ? renderHTML(data.body) : null}
                </ModalBody>

            </Modal>
        </>
    );
};

export default NotificationBody;
